import React, { useState, useEffect } from 'react';
import Watch from './components/Watch.jsx';

const TWEAK_DEFAULTS = {
  sonName: 'Andy',
  organizerName: 'Mom & Dad',
  accent: 'maroon',
};

function parseHash() {
  const raw = window.location.hash.slice(1);
  const [, q = ''] = raw.split('?');
  return { params: Object.fromEntries(new URLSearchParams(q)) };
}

export default function App() {
  const [hashInfo, setHashInfo] = useState(parseHash);

  useEffect(() => {
    document.documentElement.style.setProperty('--accent', '#861F41');
  }, []);

  useEffect(() => {
    const h = () => setHashInfo(parseHash());
    window.addEventListener('hashchange', h);
    return () => window.removeEventListener('hashchange', h);
  }, []);

  const exit = () => {
    window.location.hash = '';
    setHashInfo({ params: {} });
  };

  return <Watch tweaks={TWEAK_DEFAULTS} onExit={exit} urlParams={hashInfo.params} />;
}
